module.exports = __webpack_public_path__ + "img/图标.bc5939ca.png";